import React from 'react'

/** Small chevron SVG used for expandable sections. Uses currentColor so
 *  it inherits the surrounding text colour, and rotates via CSS when
 *  `open=true` rather than swapping glyphs — this gives us a single
 *  accessible element with an aria-label. */
export function Chevron({ open = false, size = 12, ariaLabel }: { open?: boolean; size?: number; ariaLabel?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      role={ariaLabel ? 'img' : undefined}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 120ms ease',
      }}
    >
      <polyline points="3,4.5 6,8 9,4.5" />
    </svg>
  )
}
